/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import RichTextField from '@molecules/RichTextField';

import { useMinisite } from '@api/hooks';
import { ContentModuleModal, MinisiteField, TextField } from '@molecules';

import Form from '../Form';

import Item from './Item';
import { INITIAL_VALUES, FORM_FIELD } from './constants';

const LibraryPanel = ({
  visible,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues: data = INITIAL_VALUES,
  errors,
}) => {
  const [form] = Form.useForm(FORM_FIELD);

  const minisiteQuery = useMinisite({ id: data?.minisiteId });

  React.useEffect(() => {
    if (visible && minisiteQuery.status === 'success') {
      form.setFieldsValue({ [FORM_FIELD.MINISITE.name]: minisiteQuery.data });
    }
  }, [form, minisiteQuery.data, minisiteQuery.status, visible]);

  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const formName = React.useMemo(() => `form_in_modal-${Math.random()}`, []);

  return (
    <ContentModuleModal
      visible={visible}
      title="Library"
      subtitle="Add a Library to appear on this page"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD LIBRARY'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        hideRequiredMark
        layout="vertical"
        initialValues={initialValues}
        onSerializedFinish={handleSubmit}
        name={formName}
      >
        <MinisiteField
          {...FORM_FIELD.MINISITE}
          disabled={minisiteQuery.isFetching}
          extra={null}
          wrapperCol={{ span: 12 }}
        />
        <TextField {...FORM_FIELD.TITLE} />
        <RichTextField {...FORM_FIELD.DESCRIPTION} />
      </Form>
    </ContentModuleModal>
  );
};

LibraryPanel.Item = Item;

export default LibraryPanel;
